export * from './quote.component';
